import {
  BRAND_COLLABORATION_TYPES,
  BRAND_SALES_CHANNELS,
  type BrandCollaborationType,
  type BrandSalesChannel,
} from '@fluenceur/types';
import { Code, Community, Gift, Link, Megaphone, VideoCamera } from 'iconoir-react';
import type { ComponentType, SVGProps } from 'react';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

/** Collaboration types in the order of the mock-up, with their pictogram. */
export const COLLAB_OPTIONS: { value: BrandCollaborationType; icon: IconComponent }[] =
  BRAND_COLLABORATION_TYPES.map((value) => ({
    value,
    icon: { ugc: VideoCamera, gifting: Gift, sponsored: Megaphone, affiliation: Link }[value],
  }));

export const collabTitleKey = (value: BrandCollaborationType) =>
  `onboarding.collabs.options.${value}.title`;

export const SALES_CHANNEL_OPTIONS: readonly BrandSalesChannel[] = BRAND_SALES_CHANNELS;

export const salesChannelTitleKey = (value: BrandSalesChannel) =>
  `onboarding.sales.options.${value}.title`;

/** Channels drawn with an iconoir pictogram rather than a store logo. */
export const SALES_CHANNEL_ICONS: Partial<Record<BrandSalesChannel, IconComponent>> = {
  api: Code,
  none: Community,
};

/** Orders the collaborations a brand picked the way the options are listed. */
export const inOptionOrder = (values: BrandCollaborationType[]): BrandCollaborationType[] =>
  BRAND_COLLABORATION_TYPES.filter((value) => values.includes(value));
